import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type InterviewsFetchFailedAction = {
	type: 'INTERVIEWS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): InterviewsFetchFailedAction => ({
	type: 'INTERVIEWS_FETCH_FAILED',
	payload,
});
